import axios from "axios";
import {
  documentSearchUrl,
  documentUrl,
  globalPartnerUrl,
} from "../../Config/Url";
import { documentTypes } from "../../Config/DocumentTypes";

const { returnReceipt } = documentTypes;

export const returnReceiptService = {
  documentSearch,
  documentDelete,
  documentCreate,
  documentLock,
  documentUpdate,
  getDocumentById,
  getPartnersByStoreId,
  documentDetails,
  documentCancel,
};

async function documentSearch(
  tenantId,
  pageIndex,
  pageSize,
  sortName,
  isAsc,
  storeId,
  partnerGuid,
  searchText,
  dateFrom,
  dateTo
) {
  return axios
    .put(documentSearchUrl, {
      tenantId,
      pageIndex,
      pageSize,
      sortName,
      isAsc,
      documentTypeId: returnReceipt,
      storeId: Number(storeId),
      partnerGuid,
      searchText,
      dateFrom,
      dateTo,
    })
    .then((res) => res)
    .catch((err) => err.response);
}

async function documentDelete(documentGuid) {
  return axios
    .delete(`${documentUrl}/${documentGuid}`)
    .then((res) => res)
    .catch((err) => err.response);
}

async function documentCreate(date, storeId, partnerGuid, note, products) {
  let items = products.map((item) => ({
    documentTypeId: returnReceipt,
    productGuid: item.productGuid,
    quantityOut: Number(item.quantity),
    priceOut: item.price,
  }));
  return axios
    .post(documentUrl, {
      documentTypeId: returnReceipt,
      storeId,
      date,
      note,
      partnerGuid,
      items,
    })
    .then((res) => res)
    .catch((err) => err.response);
}

async function documentLock(documentGuid) {
  return axios
    .patch(`${documentUrl}/${documentGuid}/lock`)
    .then((res) => res)
    .catch((err) => err.response);
}

async function documentUpdate(
  documentGuid,
  date,
  storeId,
  partnerGuid,
  note,
  products
) {
  let items = products.map((item) => ({
    documentDetailGuid: item.documentDetailGuid,
    documentTypeId: returnReceipt,
    productGuid: item.productGuid,
    quantityOut: Number(item.quantityOut),
    priceOut: item.priceOut,
    isActive: Boolean(item.isActive),
  }));
  return axios
    .put(`${documentUrl}/${documentGuid}`, {
      documentTypeId: returnReceipt,
      storeId,
      partnerGuid,
      date,
      note,
      items,
    })
    .then((res) => res)
    .catch((err) => err.response);
}

async function getDocumentById(documentGuid, date, storeId, note, products) {
  return axios
    .get(`${documentUrl}/${documentGuid}`)
    .then((res) => res)
    .catch((err) => err.response);
}

async function documentDetails(documentGuid) {
  return axios
    .get(`${documentUrl}/${documentGuid}/details`)
    .then((res) => res)
    .catch((err) => err.response);
}

async function getPartnersByStoreId(storeId) {
  return axios
    .get(`${globalPartnerUrl}/${storeId}`)
    .then((res) => res)
    .catch((err) => err.response);
}

async function documentCancel(documentGuid) {
  return axios
    .patch(`${documentUrl}/${documentGuid}/storno`)
    .then((res) => res)
    .catch((err) => err.response);
}
